module.exports = __webpack_public_path__ + "static/img/v75.545a22c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/v75.png
// module id = 1fGS
// module chunks = 1